import { render, staticRenderFns } from "./batch-import.vue?vue&type=template&id=735fb7ac&scoped=true&"
import script from "./batch-import.vue?vue&type=script&lang=ts&"
export * from "./batch-import.vue?vue&type=script&lang=ts&"
import style0 from "./batch-import.vue?vue&type=style&index=0&id=735fb7ac&prod&lang=scss&"
import style1 from "./batch-import.vue?vue&type=style&index=1&id=735fb7ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735fb7ac",
  null
  
)

export default component.exports